import * as auth from './auth';
import * as patientInfo from './patientInfo'
import * as appData from './appData'
export { auth, patientInfo, appData };